import React, { useEffect, useState } from "react";
import "./EventPage.scss"
import { getEventsById, processPayment } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import tick from "./assets/tick.svg"
import calendar from "./assets/calendar.svg"
import clock from "./assets/clock.svg"
import location from "./assets/location.svg"
import star from "./assets/star.svg"
import plus from "./assets/plus.svg"
import minus from "./assets/minus.svg"
import users from "./assets/users.svg"
import check from "./assets/tick-white.svg"
import secure from "./assets/secure.svg"
import guarantee from "./assets/guarm.svg"
import mobile from "./assets/mobile.svg"
import cart from "./assets/cart.svg"
import { useHistory, useLocation, useParams } from "react-router";
import moment from "moment";
import BookingModal from "./Modal/BookingModal";
import SuccessModal from "./Modal/SuccessModal";
import Modal from "../components/Modal/Modal";
import UnavailableModal from "./Modal/UnavailableModal";
import SlidingAlert from "./SlidingAlert/SlidingAlert";
import Slider from "./Slider/Slider";
import SoldoutModal from "./Modal/SoldoutModal/SoldoutModal";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../RestaurantWidget/utilities/helper/helper";
import { sendPaymentDetails } from "../../RestaurantWidget/utilities/api/paymentService";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';

const EventPage = () => {
    let params = useParams();
    const history = useHistory()
    const [data, setData] = useState(sessionStorage.getItem("event_dta") ? JSON.parse(sessionStorage.getItem("event_dta")) : null)
    const [selectedTickets, setSelectedTickets] = useState(null);
    const [showCheckout, setShowCheckout] = useState(false);
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)
    const [isOrderLoading, setIsOrderLoading] = useState(false)
    const [isBookingFailed, setIsBookingFailed] = useState(false)
    const [showUnavailable, setShowUnavailable] = useState(null)
    const [isBookingFull, setIsBookingFull] = useState(false)



    const [isLoading, setIsLoading] = useState(false)
    const [showAlert, setShowAlert] = useState(false)


    const [showSuccess, setShowSuccess] = useState(null)
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);

    const ticket = queryParams.get("ticket");
    const action = queryParams.get("action");
    const redirectResult = queryParams.get('redirectResult'); const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const storeOrderLocalData = useSelector((state) => state.companyData.company);


    useEffect(() => {
        if (params.id) {
            setIsLoading(true)

            fetchData(params.id, ticket, action)

        }
    }, [params, params.id])
    useEffect(() => {
        if (redirectResult) {
            sendPaymentDetailsRedirect()
        }
    }, [])
    const fetchData = async (id, ticket, add) => {
        let userUUID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
        const userDetails = localStorage.getItem('fullUserDetails')

        if (!userDetails) {
            if (!userUUID) {
                userUUID = uuidv4();
                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID, userUUID);
            }
        } else {
            let user = JSON.parse(localStorage.getItem('fullUserDetails'))
            userUUID = user.UserID;
            localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID, userUUID);
        }
        // EVT-2025-JAFFNA-001
        let evenData = await getEventsById(id)
        const ticketFuund = evenData?.Seats?.SeatCharges?.find((t) => t.Type === ticket);
        if (evenData && evenData !== undefined) {
            sessionStorage.setItem("event_dta", JSON.stringify(evenData))
            setData(evenData)
        } else {
            sessionStorage.removeItem("event_dta")
            setData(null)
        }
        const isSoldout = evenData?.Seats?.SeatCharges.reduce((total, seat) => total + seat.Available, 0) === 0
        if (!isSoldout) {
            if (evenData?.Seats?.TotalSeats * 0.4 >= evenData?.Seats?.SeatCharges.reduce((total, seat) => total + seat.Available, 0)) {
                setShowAlert(true)
            }
            if (ticketFuund && add && ticketFuund?.Available > 0) {
                setSelectedTickets(
                    {
                        "ChargeType": ticket,
                        "ChargeTypeDisplayName": ticketFuund?.Name,
                        "Quantity": 1,
                        "Amount": ticketFuund?.Amount
                    });
            } else if (ticketFuund && add && ticketFuund?.Available === 0 && !redirectResult) {
                setShowUnavailable(ticketFuund)
            } else {
                setShowUnavailable(null)
            }
        } else {
            setIsBookingFull(true)
        }

        setIsLoading(false)
    }
    const fetchEventData = async () => {
        if (params?.id) {
            let evenData = await getEventsById(params?.id)
            if (evenData && evenData !== undefined) {
                sessionStorage.setItem("event_dta", JSON.stringify(evenData))
                setData(evenData)
                const isSoldout = evenData?.Seats?.SeatCharges.reduce((total, seat) => total + seat.Available, 0) === 0
                if (!isSoldout) {
                    if (evenData?.Seats?.TotalSeats > 0) {
                        setShowUnavailable({
                            "ID": "000000000000000000000000",
                            "Type": "SUCCESS",
                        })
                    }
                } else {
                    setIsBookingFull(true)
                }
            } else {
                sessionStorage.removeItem("event_dta")
                setData(null)
            }
        }
    }

    const sendPaymentDetailsRedirect = () => {
        let orderID = sessionStorage.getItem("eventOID")
        if (orderID) {
            const paymentDetailsRequest = {
                cloudLocationID: storeOrderLocalData.LocationID,
                reference: `Online-${storeOrderLocalData.LocationID}-Ecom-${orderID}`,
                siteTransactionRef: orderID,
                store: `Ecommerce_${storeOrderLocalData.LocationID}`,
                countryCode: "GB",
                paymentDetailInput: {
                    redirectResult: redirectResult

                },
                shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),

            }
            setIsPaymentLoading(true)
            sendPaymentDetails(paymentDetailsRequest, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
                if (response) {
                    if (response.resultCode && response.resultCode === "Authorised") {
                        sendPaymentProcess()
                    } else {
                        setIsPaymentLoading(false)
                        setIsBookingFailed(true)
                        history.replace(`/event/${data?.EventID}`)
                    }
                } else {
                    setIsPaymentLoading(false)
                    setIsBookingFailed(true)
                    history.replace(`/event/${data?.EventID}`)
                }
            })
        } else {
            setIsPaymentLoading(false)
            setIsBookingFailed(true)
            history.replace(`/event/${data?.EventID}`)
        }

    }
    const sendPaymentProcess = async () => {
        const req = sessionStorage.getItem("event_ref_p") && JSON.parse(sessionStorage.getItem("event_ref_p"))
        if (req) {
            await processPayment(req).then((res) => {
                if (res) {
                    setIsOrderLoading(false)
                    setIsPaymentLoading(false)
                    setShowSuccess(res)
                } else {
                    setIsPaymentLoading(false)
                    setIsBookingFailed(true)
                }
            }).catch((e) => {
                setIsPaymentLoading(false)
                setIsBookingFailed(true)
            })
        } else {
            setIsPaymentLoading(false)
            setIsBookingFailed(true)

        }
    }

    const getLowestAmount = () => {
        if (!data?.Seats?.SeatCharges?.length) return null;
        return "£" + Math.min(...data?.Seats?.SeatCharges.map(seat => seat.Amount)) / 100;
    }
    const calculateTotal = () => {
        let total = 0;
        const quantity = selectedTickets?.Quantity || 0;
        const ticket = data?.Seats?.SeatCharges?.find((t) => t.Type === selectedTickets?.ChargeType);
        if (ticket) {
            total += ticket.Amount * quantity;
        }


        return total;
    };
    const updateTicketQuantity = (ticketId, change) => {
        const current = selectedTickets?.Quantity || 0;
        const newQuantity = Math.max(0, current + change);
        const ticket = data?.Seats?.SeatCharges?.find((t) => t.Type === ticketId);
        const maxQuantity = Math.min(ticket?.Available || 0, ticket?.MaxQuantityPerBooking);
        if (newQuantity === 0) {
            setSelectedTickets(null)
        } else {
            setSelectedTickets(
                {
                    "ChargeType": ticketId,
                    "ChargeTypeDisplayName": ticket?.Name,
                    "Quantity": Math.min(newQuantity, maxQuantity),
                    "Amount": ticket?.Amount
                });
        }
    };
    const getTotalTickets = () => {
        return selectedTickets?.Quantity || 0;
    };
    const calculateChargedTotal = () => {
        const totalDiscount = data?.Pricing?.TaxPercentage + data?.Pricing?.ServiceFeePercentage;
        let total = totalDiscount > 0 ? (calculateTotal() - (calculateTotal() * totalDiscount / 100)) : calculateTotal()
        return Math.round(total);
    };
    const BoldText = ({ text }) => {
        const parts = text?.split(/\*\*/);

        return (
            <div className="seat-benefits-item-text">
                {parts.map((part, index) =>
                    index % 2 === 1 ? <strong key={index}>{part}</strong> : part
                )}
            </div>
        );
    };
    return (
        isLoading ? <div className='Hospitality-loader-main'><div className='loader-spin ' /></div> : data ? <div className="EventPage">
            {isPaymentLoading &&
                <div className="EventPage-overlayer" ><div className="order-placing">Please wait your order in progress ...</div></div>
            }
            <div className="EventPage-Details">
                {showAlert && <SlidingAlert
                    message="Hurry! Tickets are Selling Fast"
                    type="error"
                    sub="Don’t miss out, grab your spot before it’s too late."
                    onClose={() => {
                        setShowAlert(false)
                    }} />}
                <div className="EventPage-Details-Container">
                    <div className="EventPage-Details-Container-banner"
                        style={{
                            backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0) 100%), url(${data?.BannerImages[0]})`
                        }}>
                        <div className="event-details-flex">
                            <div className="event-details-flex-available">
                                <div className="av" />Available Now</div>
                            <div className="event-details-flex-feature">
                                <img src={star} alt="" />Featured Event</div>
                        </div>
                        <div className="EventPage-Details-Container-banner-title">{data?.EventTitle}</div>
                        <div className="EventPage-Details-Container-banner-by">by {data?.OrganizerDetails?.Name}</div>
                        <div className="event-details-flex">
                            <div className="event-details-flex-item">
                                <img alt="" src={calendar} />   {moment(data?.EventDate).format('Do MMMM YYYY')}
                            </div>
                            <div className="event-details-flex-item">
                                <img alt="" src={clock} />   {data?.Duration?.StartTime}{data?.Duration?.EndTime ? ` - ${data?.Duration?.EndTime}` : "onwards"}
                            </div>    <div className="event-details-flex-item">
                                <img alt="" src={location} />   {data?.Venue?.Name}, {data?.Venue?.Location}
                            </div>
                        </div>
                    </div>
                    <div className="EventPage-Details-Container-content">
                        <div className="event-exp-top">
                            <div className="event-exp-title">
                                About This Experience
                            </div>
                            <div className="event-description">
                                {data?.EventDescription}
                            </div>

                        </div>
                        <div className="event-exp-btm">
                            <div className="event-exp-btm-item">
                                <div className="event-exp-btm-item-header">
                                    What's Included
                                </div>
                                <div className="event-exp-btm-item-list">
                                    {data?.MetaData?.EventHighlights?.map((highlight, key) => {
                                        return (
                                            <div className="event-exp-btm-item-list-item" key={key}>
                                                <div className="event-exp-btm-item-list-item-tick">
                                                    <img alt="" src={tick} />
                                                </div>
                                                {highlight}

                                            </div>
                                        )
                                    })}
                                </div>

                            </div>
                            <div className="event-exp-btm-item">
                                <div className="event-exp-btm-item-header">
                                    Meet Your Idol
                                </div>
                                <div className="event-exp-btm-item-content">
                                    <img alt="" src={data?.OrganizerDetails?.Image} className="chef-img" />
                                    <div className="event-exp-btm-item-content-det">
                                        <div className="event-exp-btm-item-content-det-name">
                                            {data?.OrganizerDetails?.Name}
                                        </div>
                                        <div className="event-exp-btm-item-content-det-bio">
                                            {data?.OrganizerDetails?.Bio}

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div className="EventPage-Details-Container">
                    <div className="EventPage-Details-Container-content">
                        <div className="EventPage-Details-Container-content-header">
                            Event Gallery
                        </div>
                        <div className="EventPage-Details-Container-content-grid">
                            {/* {data?.GalleryImages?.map((src, key) => {
                                return (
                                    <img alt="" src={src} key={key}
                                        className="EventPage-Details-Container-content-grid-item" />
                                )
                            })} */}
                            <Slider
                                items={data?.GalleryImages} />
                        </div>
                    </div>
                </div>
                <div className="EventPage-Details-Container">
                    <div className="EventPage-Details-Container-content">
                        <div className="EventPage-Details-Container-content-header">
                            Select Your Tickets
                            <div className="header-price-cont">
                                <div className="header-price-cont-head">
                                    Starting from
                                </div>
                                <div className="header-price-cont-price">
                                    {getLowestAmount()}
                                </div>
                            </div>
                        </div>
                        <div className="Event-Seats">
                            {data?.Seats?.SeatCharges?.map((seat, key) => {
                                return (
                                    <div key={key} className="Event-Seats-item">
                                        <div
                                            className="Event-Seats-item-header">
                                            <div className="Event-Seats-item-header-left">
                                                <div className="seat-header">{seat?.Name}
                                                    {seat.OriginalPrice > seat.Amount && <div className="seat-header-save">Save £ {(seat?.OriginalPrice - seat?.Amount) / 100}</div>}
                                                </div>
                                                <div className="seat-price-cont">
                                                    <div className="seat-price-cont-amount"> £ {seat.Amount / 100}</div>
                                                    {seat.OriginalPrice > seat.Amount && <div className="seat-price-cont-org"> £ {seat.OriginalPrice / 100}</div>}
                                                    <div className="seat-price-cont-txt">per person</div>
                                                </div>
                                                {seat.Available > 0 ? <div className="seat-remaining">
                                                    Limited Tickets Available
                                                </div> : <div className="seat-unavailable">Unavailable</div>}

                                            </div>
                                            {seat?.Available > 0 && <div className="Event-Seats-item-header-right">
                                                <div

                                                    className={`${selectedTickets?.ChargeType === seat.Type ? "Event-Seats-item-header-right-action" : "Event-Seats-item-header-right-disable"}`}
                                                    onClick={() => {
                                                        if (selectedTickets?.ChargeType === seat.Type) {
                                                            updateTicketQuantity(seat.Type, -1)
                                                        }
                                                    }
                                                    }
                                                ><img alt="" src={minus} /></div>
                                                <div
                                                    className={`Event-Seats-item-header-right-count`}>
                                                    {selectedTickets?.ChargeType === seat.Type ? selectedTickets?.Quantity || 0 : 0}
                                                </div>
                                                <div
                                                    className={`${!selectedTickets || (selectedTickets?.ChargeType === seat.Type && seat.Available > selectedTickets.Quantity)
                                                        ? "Event-Seats-item-header-right-action"
                                                        : "Event-Seats-item-header-right-disable"}`}
                                                    onClick={() => {
                                                        if (!selectedTickets || (selectedTickets?.ChargeType === seat.Type && seat.Available > selectedTickets.Quantity)) {
                                                            updateTicketQuantity(seat.Type, 1)
                                                        }
                                                    }}
                                                >
                                                    <img alt="" src={plus} />
                                                </div>


                                            </div>}
                                        </div>
                                        <div className="seat-benefits">
                                            {seat?.Benefits?.map((benefit, key) => {
                                                return (
                                                    <div key={key} className="seat-benefits-item">
                                                        <div className="seat-benefits-item-check">
                                                            <img alt="" src={check} /></div>{<BoldText text={benefit} />}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {getTotalTickets() > 0 &&
                            <div className="event-tickt-select">
                                <div
                                    className="event-tickt-select-left">
                                    <div
                                        className="event-tickt-select-left-text">  {getTotalTickets()} ticket
                                        {getTotalTickets() > 1 ? "s" : ""} selected</div>
                                    <div
                                        className="event-tickt-select-left-sub">     Ready to complete your booking?</div></div>
                                <div
                                    className="event-tickt-select-button"
                                    onClick={() => {
                                        setShowCheckout(true)
                                    }}>Continue to Checkout</div></div>}
                    </div>
                </div>
            </div>
            <div className="EventPage-Summary">
                <div className="EventPage-Summary-Container">
                    <div className="EventPage-Summary-Container-header">
                        <div className="EventPage-Summary-Container-header-text">
                            Booking Summary
                        </div>
                        <div className="EventPage-Summary-Container-header-subtext">
                            Secure your spot today
                        </div>
                    </div>
                    <div className="EventPage-Summary-Container-Details">
                        <div className="EventPage-Summary-Container-Details-header2">
                            {data?.EventTitle}
                        </div>
                        <div className="EventPage-Summary-Container-Details-eventDet">
                            <div className="EventPage-Summary-Container-Details-eventDet-item">
                                <img alt="" src={calendar} />   {moment(data?.EventDate).format('Do MMMM YYYY')}
                            </div>
                            <div className="EventPage-Summary-Container-Details-eventDet-item">
                                <img alt="" src={clock} />   {data?.Duration?.StartTime}{data?.Duration?.EndTime ? ` - ${data?.Duration?.EndTime}` : "onwards"}
                            </div>
                            <div className="EventPage-Summary-Container-Details-eventDet-item">
                                <img alt="" src={location} />   {data?.Venue?.Name}, {data?.Venue?.Location}
                            </div>
                        </div>
                        {getTotalTickets() > 0 && <div className="EventPage-Summary-Container-Details-Price">

                            <div className="EventPage-Summary-Container-Details-Price-item">
                                <div className="EventPage-Summary-Container-Details-Price-item-left">
                                    <div className="EventPage-Summary-Container-Details-Price-item-left-name">
                                        {selectedTickets?.ChargeTypeDisplayName}
                                    </div>
                                    <div className="EventPage-Summary-Container-Details-Price-item-left-amount">
                                        £{(selectedTickets?.Amount) / 100} × {selectedTickets?.Quantity}
                                    </div>
                                </div>
                                <div className="EventPage-Summary-Container-Details-Price-item-right">
                                    £{((selectedTickets?.Amount) / 100 || 0) * selectedTickets?.Quantity}
                                </div>
                            </div>

                        </div>}
                        {getTotalTickets() > 0 && <>     <div className="EventPage-Summary-Container-Details-Value">
                            <div className="EventPage-Summary-Container-Details-Value-cal">Subtotal                 <div>£{(calculateTotal() / 100).toFixed(2)}</div> </div>
                            {data?.Pricing?.ServiceFeePercentage > 0 && <div className="EventPage-Summary-Container-Details-Value-cal">Service Charge <div>£{Math.round((calculateTotal() * (data?.Pricing?.ServiceFeePercentage / 100)) / 100).toFixed(2)}</div> </div>}
                            {data?.Pricing?.TaxPercentage > 0 && <div className="EventPage-Summary-Container-Details-Value-cal">VAT ({data?.Pricing?.TaxPercentage}%) <div>£{Math.round((calculateTotal() * (data?.Pricing?.TaxPercentage / 100)) / 100).toFixed(2)}</div> </div>}
                        </div>
                            <div className="EventPage-Summary-Container-Details-Value">
                                <div className="EventPage-Summary-Container-Details-Value-total">Total<div className="EventPage-Summary-Container-Details-Value-total-amount">£{(calculateChargedTotal() / 100).toFixed(2)}</div> </div>
                            </div>
                            <div className="EventPage-Summary-Container-Details-Button"
                                onClick={() => {
                                    setShowCheckout(true)
                                }}>
                                <img src={cart} alt="" />   Secure Booking - £{(calculateChargedTotal() / 100).toFixed(2)}
                            </div>
                        </>}
                    </div>
                </div>
                <div className="EventPage-Summary-Container">
                    <div className="EventPage-Summary-Container-Details">
                        <div className="EventPage-Summary-Container-Details-header">
                            Why Book With Us?
                        </div>
                        <div className="EventPage-Summary-Container-Details-list">
                            <div className="EventPage-Summary-Container-Details-list-item">
                                <img alt="" src={secure} />
                                Secure payment processing
                            </div>
                            <div className="EventPage-Summary-Container-Details-list-item">
                                <img alt="" src={guarantee} />

                                100% money-back guarantee
                            </div>  <div className="EventPage-Summary-Container-Details-list-item">
                                <img alt="" src={mobile} />
                                Instant e-ticket delivery
                            </div>
                            {/* <div className="EventPage-Summary-Container-Details-list-item">
                                <img alt="" src={support} />
                                24/7 customer support
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>
            {showCheckout && <BookingModal
                data={data}
                onClose={() => {
                    setShowCheckout(false)
                }}
                selectedTickets={selectedTickets}
                setIsPaymentLoading={setIsPaymentLoading}
                isOrderLoading={isOrderLoading}
                setIsOrderLoading={setIsOrderLoading}
                setIsBookingFailed={setIsBookingFailed}
                setShowCheckout={setShowCheckout} />}
            {showSuccess && <SuccessModal
                event={data}
                data={showSuccess}
                onClose={() => {
                    history.replace(`/event/${data?.EventID}`)
                    setShowSuccess(null)
                    fetchEventData()

                }} />}
            <Modal type={"failed"}
                visibility={isBookingFailed}
                headerText={"Your booking could not be processed"}
                subText={"Please try again, or contact support."}
                onPopupClose={() => {
                    history.replace(`/event/${data?.EventID}`)
                    setIsBookingFailed(false)
                }} />
            {showUnavailable && <UnavailableModal
                data={data}
                selectedTickets={selectedTickets}
                setSelectedTickets={setSelectedTickets}
                setShowCheckout={setShowCheckout}
                onClose={() => {
                    history.replace(`/event/${data?.EventID}`)
                    setSelectedTickets(null)
                    setShowUnavailable(null)
                }}
                setShowUnavailable={setShowUnavailable}
                showUnavailable={showUnavailable} />
            }
            <SoldoutModal
                visibility={isBookingFull}
                headerText={"Oops… We’re Out of Tickets!"}
                subText={"You missed this one, but keep an eye out, more amazing experiences are coming soon!"}
                btnText="View Event"
                onPopupClose={() => {
                    setIsBookingFull(false)
                }} />
        </div> : <div className="EventPage-empty">


            <div className="EventPage-empty-header">Oops! Event Missing</div>
            <div className="EventPage-empty-subheader">Looks like this event isn’t available right now. Try exploring other events!</div>

        </div>
    )

}
export default EventPage